import {AllowPrivateMessages, ClientUser, Roles, Sex} from "./user";

export const serviceUser: ClientUser = {
    login: "",
    sex: Sex.male,
    willDelete: null,
    registered: true,
    invisible: false,
    allowPrivateMessages: AllowPrivateMessages.disabled,
    roles: [Roles.ADMIN, Roles.MODERATOR]
};